import { useEffect, useState } from "react";
import { getShopbyDesign } from "../services/shopbydesign.service";

export const useShopbyDesign = () => {
  const [carpets, setCarpets] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchCarpets = async () => {
      const banners = await getShopbyDesign();

      const mappedData = banners
        .map((item, index) => ({
          id: item.id,
          title: item.name || `Design ${index + 1}`, 
          image: item.media?.desktop || item.media?.mobile, 
          link: item.actionLink || "/",
        }));

      setCarpets(mappedData);
      setLoading(false);
    };

    fetchCarpets();
  }, []);

  return { carpets, loading };
};